export default __webpack_public_path__ + "static/media/Cattura8.b14d5979.jpg";